import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { isAdminRole } from '@/lib/role';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const userRole = useAuthStore((state) => state.user?.role);

  if (!isAdminRole(userRole)) {
    return <Navigate to='/403' replace />;
  }

  return <>{children}</>;
}
